module.exports = __webpack_public_path__ + "img/7.6b8fc367.jpg";